import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { EventEmitter } from "@angular/core";
@Injectable()
export class SideNavService {
  public _opened = false;
  private sideNavSubject = new Subject<SideNavState>();
  sideNavState = this.sideNavSubject.asObservable();
  constructor() {}
  _show() {
    this.sideNavSubject.next(<SideNavState>{ _opened: true });
  }
  _hide() {
    this.sideNavSubject.next(<SideNavState>{ _opened: false });
  }
}
export interface SideNavState {
  _opened: boolean;
}
